import _reject from 'lodash/reject';

// Takes a roster array (e.g. from useFullRoster), not Redux state.
export const getActiveStudents = (roster) => _reject(roster, 'studentDropDate');

export const enrolledLengthSelector = (roster) =>
  getActiveStudents(roster).length;
